module.exports = __webpack_public_path__ + "img/大图--复古.b459ac4a.png";